<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_301_5987)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.2935 0.565918C5.98619 0.565918 0.871582 5.68247 0.871582 11.9952C0.871582 16.6736 3.68407 20.6948 7.7094 22.4621C7.67717 21.6651 7.70403 20.7055 7.90684 19.8373C8.12711 18.91 9.37622 13.6106 9.37622 13.6106C9.37622 13.6106 9.01224 12.8808 9.01224 11.8016C9.01224 10.1082 9.99405 8.84352 11.2149 8.84352C12.2532 8.84352 12.7555 9.62437 12.7555 10.5598C12.7555 11.6041 12.0893 13.1671 11.7468 14.6146C11.4607 15.8282 12.3539 16.816 13.5493 16.816C15.7131 16.816 17.1704 14.0353 17.1704 10.7399C17.1704 8.23604 15.4847 6.36118 12.4184 6.36118C8.95447 6.36118 6.79611 8.94566 6.79611 11.8325C6.79611 12.8298 7.08889 13.5313 7.54823 14.0743C7.76045 14.3256 7.78865 14.4251 7.71209 14.7127C7.65836 14.921 7.53212 15.429 7.47974 15.6293C7.40318 15.9183 7.16947 16.0231 6.9089 15.9156C5.31193 15.2637 4.5692 13.5152 4.5692 11.549C4.5692 8.30324 7.30513 4.40837 12.7313 4.40837C17.0925 4.40837 19.9627 7.56808 19.9627 10.9563C19.9627 15.4398 17.4726 18.789 13.7991 18.789C12.5675 18.789 11.407 18.1224 11.0095 17.3657C11.0095 17.3657 10.3459 19.9986 10.2063 20.5066C9.9645 21.3869 9.4904 22.2686 9.05657 22.954C10.0841 23.2578 11.1693 23.4231 12.2935 23.4231C18.6008 23.4231 23.714 18.3065 23.714 11.9952C23.714 5.68247 18.6008 0.565918 12.2935 0.565918Z"
        fill="#A9A9A9"
      />
    </g>
    <defs>
      <clipPath id="clip0_301_5987">
        <rect
          width="24"
          height="22.8571"
          fill="white"
          transform="translate(0 0.566406)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "AppPinterestIcon",
};
</script>
